export const onChangeBackupMode = (state, { mode }) => {
  const agent = state.productCode.toLowerCase()
  return {
    ...state,
    [agent]: {
      ...state[agent],
      mode,
      nodeIds: mode === "MANUAL" ? state[agent].nodeIds : [],
    },
  }
}

export const onSaveBackupConsolePassword = (state, { consolePassword }) => {
  const agent = state.productCode.toLowerCase()
  return {
    ...state,
    [agent]: {
      ...state[agent],
      consolePassword,
    },
  }
}

export const onSelectBackupNode = (state, { nodeIds }) => {
  const agent = state.productCode.toLowerCase()
  return {
    ...state,
    [agent]: {
      ...state[agent],
      nodeIds,
    },
  }
}

export const onSaveBackupBandwidthThrottleKb = (state, { bandwidthThrottleKb }) => {
  const agent = state.productCode.toLowerCase()
  return {
    ...state,
    [agent]: {
      ...state[agent],
      bandwidthThrottleKb,
    },
  }
}

export const onSaveBackupBandwidthThrottle = (state, { bandwidthThrottle }) => {
  const agent = state.productCode.toLowerCase()
  return {
    ...state,
    [agent]: {
      ...state[agent],
      bandwidthThrottle,
    },
  }
}

export const onSaveBackupNetworkLocation = (state, { networkLocation }) => {
  const agent = state.productCode.toLowerCase()
  return {
    ...state,
    [agent]: {
      ...state[agent],
      networkLocation,
    },
  }
}
